document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-container').forEach(function(product) {
    const variantId = product.dataset.variantId;
    const minusButton = product.querySelector('.btn-minus');
    const plusButton = product.querySelector('.btn-plus');
    const quantityDisplay = product.querySelector('.quantity-display');
    const addToCartButton = product.querySelector('.add-to-cart-btn');

    minusButton.addEventListener('click', function() {
      changeQuantity(-1, variantId, quantityDisplay, product);
    });

    plusButton.addEventListener('click', function() {
      changeQuantity(1, variantId, quantityDisplay, product);
    });

    addToCartButton.addEventListener('click', function() {
      addToCart(variantId, quantityDisplay, product);
    });

    //addToCartButton.textContent = '+ Keranjang';
  });
});

function updateCartCountBubble(itemCount) {
  // Select all elements with the class 'cart-count-bubble'
  const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');

  // Update each cart count bubble with the new item count
  cartCountBubbles.forEach(function(bubble) {
    const countSpan = bubble.querySelector('span');
    if (countSpan) {
      countSpan.textContent = itemCount;
    }
  });
}

function addToCart(variantId, quantityDisplay, productElement) {
  // Define the product ID and quantity
  let data = {
    items: [{
      id: variantId, // Replace with your product variant ID
      quantity: 1 // The quantity to add
    }]
  };

  productElement.querySelector('.quantity-selector').style.display = 'flex';
  productElement.querySelector('.add-to-cart-btn').style.display = 'none';
  quantityDisplay.textContent = `1`;
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    // The item was successfully added to the cart, so fetch the updated cart data
    return fetch('/cart.js');
  })
  .then(response => response.json())
  .then(updatedCartData => {
    updateCartCountBubble(updatedCartData.item_count);
  })
  .catch(error => {
    console.error('There was a problem adding the item to the cart:', error);
  });
}

function changeQuantity(change, variantId, quantityDisplay, productElement) {
  let currentQuantity = parseInt(quantityDisplay.textContent) || 0;
  let newQuantity = currentQuantity + change;

  if (newQuantity <= 0) {
    // If the quantity is zero, hide the quantity selector and show the "Add to Cart" button
    newQuantity = 0; // Ensuring quantity is not negative
    productElement.querySelector('.quantity-selector').style.display = 'none';
    productElement.querySelector('.add-to-cart-btn').style.display = 'block';
  } else {
    // If the quantity is more than zero, update the display and ensure the "Add to Cart" button is hidden
    productElement.querySelector('.quantity-selector').style.display = 'flex';
    productElement.querySelector('.add-to-cart-btn').style.display = 'none';
    quantityDisplay.textContent = `${newQuantity}`;
  }

  // Update quantity on Shopify
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      updates: {
        [variantId]: newQuantity
      }
    })
  })
  .then(response => response.json())
  .then(cart => {
    // Update the cart count bubble
    updateCartCountBubble(cart.item_count);
  })
  .catch(error => {
    console.error('Error updating cart quantity:', error);
  });
}   
